import { pagesModule } from '@/store/database/pagesModule';
import { updatePage, deleteNote } from '../../../../components/ContextDoc/use/useDocActions';
import { reactive, toRefs } from '@vue/composition-api';
import { collection, getDoc, doc, getFirestore } from 'firebase/firestore';

const state = reactive({
  show: false, //  true or false
  selectedNoteId: null,
  parentPageId: null
});

export default function useMoveTo() {
  const openMoveTo = ({ selectedNoteId, parentPageId }) => {
    console.log('open move to', selectedNoteId, parentPageId);
    state.selectedNoteId = selectedNoteId;
    state.parentPageId = parentPageId;
    state.show = true;
  };
  const closeMoveTo = () => {
    state.show = null;
    state.selectedNoteId = null;
    state.parentPageId = null;
  };
  const moveNote = async ({ targetContextId }) => {
    //  Here are are duplicating a note into the base page of a different context
    //  We then update the context field on all associated pages so they load when you load that context
    // finally we remove the inital note
    console.log('start moveNote');
    const db = getFirestore();
    //  First get the context we are sending to
    const targetContextDoc = await getDoc(doc(collection(db, 'contexts'), targetContextId));
    const targetContext = targetContextDoc.data();
    const basePageId = targetContext.basePage;
    console.log('got target context', targetContext);

    //  Fetch the base page

    const basePageRef = doc(collection(db, 'pages'), basePageId);
    const basePageDoc = await getDoc(basePageRef);
    const basePage = basePageDoc.data();
    console.log('got base page', basePage);

    // clone note
    const note = pagesModule.doc(state.parentPageId).data.pageNotes[state.selectedNoteId];
    console.log('got original note', note);
    const newNote = { ...note };

    const getPageNotes = page => {
      return Object.values(page.pageNotes)
        .filter(n => !n.toDelete && n !== undefined && n.id)
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    };

    //  fix note order
    const basePageNotes = getPageNotes(basePage);
    const order = basePageNotes.length;
    newNote.order = order;

    //  Move all pages into target context

    const deepMovePageContext = pageId => {
      const movedPage = pagesModule.doc(pageId).data;
      //    update all it's children pages
      const movedPageNotes = getPageNotes(movedPage);
      movedPageNotes.forEach(note => {
        console.log('run deep move on child note', note);
        deepMovePageContext(note.pageId);
      });

      //    update this page's context
      updatePage({ pageId, update: { context: targetContextId }});
      // store.dispatch('pages/patch', { id: pageId, context: targetContextId });
      console.log('updated page context', pageId);
    };

    deepMovePageContext(newNote.pageId);
    // add note to basePage
    const baseUpdate = {};
    baseUpdate['pageNotes.' + newNote.id] = newNote;
    basePageRef.update(baseUpdate);

    //  clean up note on parent page
    deleteNote({ noteId: newNote.id, pageId: state.parentPageId })
    console.log('cleaned up note');
    closeMoveTo();
  };

  return { moveNote, openMoveTo, closeMoveTo, ...toRefs(state) };
}
